let Constants = {
    API_PROMOCODE: "fiori-2026",
    CH_PROMO: "CH_1141_MLB_WEB_FDM2026_NAV_NAV_20260901_20260914",
    PROMO_CODE: "1141"
}

export default Constants;